import { assetType, routeData } from '@constants/routes.const'
import { VelvetSDK } from 'sdk'

export const getCategoryResults = async (genre: string, userCountry: string, language?: string) => {
  const categoryMovieData = await VelvetSDK.CMS.service().fetchCategoryData(
    routeData.CATEGORY,
    genre,
    assetType.MOVIE,
    language,
    userCountry
  )
  const categorySeriesData = await VelvetSDK.CMS.service().fetchCategoryData(
    routeData.CATEGORY,
    genre,
    assetType.SERIE,
    language,
    userCountry
  )
  const errorResponse = categoryMovieData?.error !== undefined && categorySeriesData?.error !== undefined
  const movieDataSeriesError = categorySeriesData?.error !== undefined && categoryMovieData?.items?.length > 0
  const seriesDataMoviesError = categoryMovieData?.error !== undefined && categorySeriesData?.items?.length > 0
  const moviesAndSeriesData = categoryMovieData?.items?.length > 0 && categorySeriesData?.items?.length > 0
  const movieDataSeriesEmpty = categoryMovieData?.items?.length > 0 && categorySeriesData?.items?.length === 0
  const seriesDataMoviesEmpty = categorySeriesData?.items?.length > 0 && categoryMovieData?.items?.length === 0

  if (categoryMovieData || categorySeriesData) {
    switch (true) {
      case errorResponse:
        return categoryMovieData
      case movieDataSeriesError:
        return categoryMovieData.items
      case seriesDataMoviesError:
        return categorySeriesData.items
      case moviesAndSeriesData:
        return categoryMovieData.items.concat(categorySeriesData.items)
      case movieDataSeriesEmpty:
        return categoryMovieData.items
      case seriesDataMoviesEmpty:
        return categorySeriesData.items
      default:
        return []
    }
  } else {
    return []
  }
}
